import Component from '../abstracts/Component';


/**
 PhoneWithPrefixHandlerComponent
 */
export default class PhoneWithPrefixHandlerComponentChina extends Component {

  get SELECTORS() {
    const container = '.phone-with-prefix-form-group';
    const phonePrefix = `#phonePrefix`;
    const phoneIdDataAttrSelector = `input[data-id]`;
    return {
      container,
      phonePrefix,
      phoneIdDataAttrSelector,
      phoneToCopySelector: `${container} ${phoneIdDataAttrSelector}`,
      phonePrefixSelector: `${container} ${phonePrefix}`,
    };
  }

  constructor() {
    super();
  }

  render() {
    const {container,phoneIdDataAttrSelector,phoneToCopySelector,phonePrefixSelector,phonePrefix} = this.SELECTORS;

    if($(container).length>0) {
      $(document).on('change', `${phoneToCopySelector},${phonePrefixSelector}`, function () {

        const $closestPhonePrefixFormGroup = $(this).closest(container);
        const $phoneToCopy = $(phoneIdDataAttrSelector, $closestPhonePrefixFormGroup);
        // Jquery can't match element which contains "." without a proper escaping
        const phoneToApplyActualId = (`#${$phoneToCopy.data('id')}` || "").replace(".","\\.");
        const $phoneToApply = $(phoneToApplyActualId, $closestPhonePrefixFormGroup);

        if($phoneToApply.length>0){
          const $prefix = $(phonePrefix, $closestPhonePrefixFormGroup);
          const prefix = $prefix.val() || '';
          $phoneToApply.val("" + prefix + "" + ($phoneToCopy.val() || '').trim());
        }
      })
    }
  }

}
